import React, { useCallback, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useSnackbar } from 'notistack'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  TextField,
} from '@mui/material'
import api from 'utils/api'
import * as businessActions from 'modules/Business/actions'

const promotionErrors = {
  PROMOTION_FUNDING_REQUIRED: 'Please fund your account before redeeming this coupon.',
  PROMOTION_PENDING: "This account's offer from this campaign is being processed. Please wait before trying again.",
}

const AddPromo = ({ businessId, onClose }) => {
  const [coupon, setCoupon] = useState('')
  const [error, setError] = useState()
  const [busy, setBusy] = useState(false)
  const submitting = useRef(false)
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()

  const handleCouponChange = useCallback(
    (e) => {
      setCoupon(e.target.value)
      setError(undefined)
    },
    [setCoupon]
  )

  const handleSubmit = useCallback(() => {
    if (submitting.current || !coupon.trim()) return
    submitting.current = true
    setBusy(true)
    setError(undefined)
    api
      .post(`/business/${businessId}/applyCoupon/${encodeURIComponent(coupon.trim())}`)
      .then(() => {
        enqueueSnackbar('Coupon applied', { variant: 'success' })
        onClose()
        dispatch(businessActions.fetchBusiness(businessId, true))
      })
      .catch(requestError => {
        setError(promotionErrors[requestError.code] || 'Coupon is not valid')
      })
      .finally(() => { submitting.current = false; setBusy(false) })
  }, [coupon, dispatch, businessId, enqueueSnackbar, onClose])

  return (
    <Dialog open fullWidth maxWidth="sm" onClose={busy ? undefined : onClose}>
      <DialogTitle>Enter promo code</DialogTitle>
      <DialogContent>
        <FormControl variant="outlined" fullWidth>
          <TextField
            disabled={busy}
            error={!!error}
            helperText={error}
            label="Coupon code"
            variant="outlined"
            onChange={handleCouponChange}
            value={coupon}
            margin="dense"
            style={{ marginTop: 4 }}
          />
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Box display="flex" justifyContent="flex-end">
          <Button color="primary" disabled={busy} onClick={onClose}>
            Cancel
          </Button>
          <Button
            color="primary"
            disabled={busy || !coupon.trim()}
            variant="contained"
            onClick={handleSubmit}
          >
            {busy ? 'Submitting…' : 'Submit'}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  )
}

export default AddPromo
